import React from 'react';
import { Container } from 'react-bootstrap';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Header } from '../components';
import {
    AdministratorScreen,
    AuthenticationScreen,
    CreateDocumentScreen,
    CreateDocumentTypeScreen,
    DocumentTypeScreen,
    HomeScreen,
    DocumentDetailScreen,
    GroupScreen,
    ModerationUserScreen,
    RegistrationScreen,
    ModerationScreen,
    EditDocumentScreen,
    ModerationGroupScreen,
    GenerateResultScreen,
} from '../screens';
import routes from './routes';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function MainRouter() {
    return (
        <Router>
            <Header />
            <Container>
                <Switch>
                    <Route exact path={routes.home} component={HomeScreen} />
                    <Route path="/auth" component={AuthenticationScreen} />
                    <Route path="/admin" component={AdministratorScreen} />
                    <Route path={`${routes.documentType}/:id`} component={DocumentTypeScreen} />
                    <Route path={routes.createDocument} component={CreateDocumentScreen} />
                    <Route path={routes.createDocument} component={CreateDocumentScreen} />
                    <Route path={`${routes.generateResult}/:id`} component={GenerateResultScreen} />
                    <Route path={`${routes.editDocument}/:id`} component={EditDocumentScreen} />
                    <Route path={routes.createDocumentType} component={CreateDocumentTypeScreen} />
                    <Route path={`${routes.documentDetail}/:id`} component={DocumentDetailScreen} />
                    <Route path={`${routes.group}/:id`} component={GroupScreen} />
                    <Route path={routes.group} component={GroupScreen} />
                    <Route path={`${routes.user}/:id`} component={ModerationUserScreen} />
                    <Route path={routes.registration} component={RegistrationScreen} />
                    <Route exact path={routes.moderation} component={ModerationScreen} />
                    <Route exact path={routes.moderationGroup} component={ModerationGroupScreen} />
                    <Route path={`${routes.moderationGroup}/:id`} component={ModerationGroupScreen} />
                </Switch>
            </Container>
            {/* <RegistrationScreen /> */}
        </Router>
    );
}

export default MainRouter;
